import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import "./scss/index.scss";
import { useCart, useSignOut, useUserDetails } from "@sdk/react";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { Link, NavLink } from "react-router-dom";
import ReactSVG from "react-svg";
import { MenuDropdown, Offline, Online, OverlayContext, OverlayTheme, OverlayType } from "..";
import { linkResolver } from "../../@prismic/prismic-config";
import { RudderAnalytics } from "../../app/analitics";
import * as appPaths from "../../app/routes";
import { mediumScreen } from "../../globalStyles/scss/variables.scss";
import cartImg from "../../images/cart.svg";
import EmailImage from "../../images/email-nav-menu.svg";
import heartImg from "../../images/heart.svg";
import logoMobile from "../../images/logo-mobile.svg";
import logoImg from "../../images/logo.svg";
import NoPhoto from "../../images/no-photo.svg";
import PhoneImage from "../../images/phone-nav-menu.svg";
import userImg from "../../images/user.svg";
import userImgLogged from "../../images/userLogged.svg";
import { WishlistCount } from "../MainMenu/WishlistCount";
import NavItem from "./NavItem";
import { NavLocales } from "./NavLocales";

var NavList = function NavList(_ref) {
  var hideOverlay = _ref.hideOverlay,
      items = _ref.items,
      allTypesImage = _ref.allTypesImage,
      prismicNav = _ref.prismicNav;
  var intl = useIntl();

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var _useCart = useCart(),
      cartItems = _useCart.items;

  var _useSignOut = useSignOut(),
      _useSignOut2 = _slicedToArray(_useSignOut, 1),
      signOut = _useSignOut2[0];

  var _useState = useState(items),
      _useState2 = _slicedToArray(_useState, 2),
      displayedItems = _useState2[0],
      setDisplayedItems = _useState2[1];

  var handleSignOut = function handleSignOut() {
    // @analitics
    RudderAnalytics.identify("", {
      isLoggedIn: false
    });
    signOut();
  };

  var handleShowSubItems = function handleShowSubItems(item) {
    setDisplayedItems(item.children);
  };

  var cartItemsQuantity = cartItems && cartItems.reduce(function (prevVal, currVal) {
    return prevVal + currVal.quantity;
  }, 0) || 0;
  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement("div", {
      className: "side-nav__wr"
    }, React.createElement("div", {
      className: "side-nav__topbar"
    }, React.createElement("span", {
      className: "side-nav__topbar-close",
      onClick: hideOverlay,
      onKeyDown: hideOverlay
    }, React.createElement("span", {
      className: "side-nav__topbar-close-btn"
    })), React.createElement(Link, {
      to: appPaths.baseUrl,
      className: "side-nav__topbar-logo",
      onClick: hideOverlay
    }, React.createElement("img", {
      src: logoImg,
      alt: "Reno",
      className: "side-nav__topbar-logo-tablet"
    }), React.createElement("img", {
      src: logoMobile,
      alt: "Reno",
      className: "side-nav__topbar-logo-mobile"
    })), React.createElement("div", {
      className: "topbar-menu"
    }, React.createElement("ul", {
      className: "topbar-menu__list"
    }, React.createElement(Online, null, React.createElement(React.Fragment, null, user ? React.createElement(NavLink, {
      to: "/wishlist",
      className: "topbar-menu__nav-link"
    }, React.createElement(ReactSVG, {
      path: heartImg,
      className: "topbar-menu__wishlist-icon"
    }), React.createElement(WishlistCount, null)) : React.createElement("a", {
      className: "topbar-menu__nav-link",
      onClick: function onClick(e) {
        e.preventDefault();
        overlayContext.show(OverlayType.login, OverlayTheme.modal);
      },
      onKeyDown: function onKeyDown(e) {
        e.preventDefault();
        overlayContext.show(OverlayType.login, OverlayTheme.modal);
      }
    }, React.createElement(ReactSVG, {
      path: heartImg,
      className: "topbar-menu__wishlist-icon"
    })), user ? React.createElement(MenuDropdown, {
      head: React.createElement("li", null, React.createElement(ReactSVG, {
        path: user ? userImgLogged : userImg
      })),
      content: React.createElement("ul", {
        className: "topbar-menu__dropdown"
      }, React.createElement("li", {
        "data-testid": "my_account__link"
      }, React.createElement(Link, {
        to: appPaths.orderHistoryUrl
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "My orders",
        "id": "components.MobileNav.NavList.1045389126"
      }, "id", "components.MobileNav.NavList.1045389126")))), React.createElement("li", {
        "data-testid": "order_history__link"
      }, React.createElement(Link, {
        to: appPaths.accountUrl
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Personal details",
        "id": "components.MobileNav.NavList.3253048083"
      }, "id", "components.MobileNav.NavList.3253048083")))), React.createElement("li", {
        "data-testid": "address_book__link"
      }, React.createElement(Link, {
        to: appPaths.addressBookUrl
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Billing address",
        "id": "components.MobileNav.NavList.2428885633"
      }, "id", "components.MobileNav.NavList.2428885633")))), React.createElement("li", {
        "data-testid": "address_book__link"
      }, React.createElement(Link, {
        to: appPaths.addressBookUrl
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Shipping address",
        "id": "components.MobileNav.NavList.3517722732"
      }, "id", "components.MobileNav.NavList.3517722732")))), React.createElement("li", {
        "data-testid": "logout-link",
        onClick: handleSignOut
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Log Out",
        "id": "components.MobileNav.NavList.2947231211"
      }, "id", "components.MobileNav.NavList.2947231211"))))
    }) : React.createElement("li", {
      "data-testid": "login-btn",
      className: "topbar-menu__icon topbar-menu__user-icon",
      onClick: function onClick() {
        return overlayContext.show(OverlayType.login, OverlayTheme.modal);
      }
    }, React.createElement(ReactSVG, {
      path: userImg
    }))), React.createElement("li", {
      className: "topbar-menu__icon topbar-menu__cart",
      onClick: function onClick() {
        overlayContext.show(OverlayType.cart, OverlayTheme.right);
      }
    }, React.createElement(ReactSVG, {
      path: cartImg
    }), cartItemsQuantity > 0 ? React.createElement("span", {
      className: "topbar-menu__cart__quantity"
    }, cartItemsQuantity) : null)), React.createElement(Offline, null, React.createElement("li", {
      className: "topbar-menu__offline"
    }, React.createElement(Media, {
      query: {
        minWidth: mediumScreen
      },
      render: function render() {
        return React.createElement("span", null, intl.formatMessage(_defineProperty({
          defaultMessage: "Offline",
          "id": "components.MobileNav.NavList.4144939532"
        }, "id", "components.MobileNav.NavList.4144939532")));
      }
    })))))), React.createElement("div", {
      className: "side-nav__body"
    }, React.createElement(NavLocales, null), React.createElement("ul", {
      className: "side-nav__menu"
    }, displayedItems.map(function (item) {
      var _item$category, _item$category$backgr;

      return React.createElement(NavItem, _extends({
        key: item.id,
        allTypesImage: allTypesImage,
        hideOverlay: hideOverlay,
        showSubItems: handleShowSubItems,
        imageUrl: ((_item$category = item.category) === null || _item$category === void 0 ? void 0 : (_item$category$backgr = _item$category.backgroundImage) === null || _item$category$backgr === void 0 ? void 0 : _item$category$backgr.url) || NoPhoto
      }, item));
    })), React.createElement("ul", {
      className: "side-nav__navigation"
    }, React.createElement("li", {
      className: "side-nav__navigation-item"
    }, React.createElement(NavLink, {
      exact: true,
      to: appPaths.baseUrl,
      className: "side-nav__navigation-item-link",
      onClick: hideOverlay
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Home",
      "id": "components.MobileNav.NavList.874908955"
    }, "id", "components.MobileNav.NavList.874908955")))), prismicNav && (prismicNav === null || prismicNav === void 0 ? void 0 : prismicNav.map(function (item, i) {
      var primary = item.primary;
      var label = primary.label,
          link = primary.link;
      return React.createElement("li", {
        className: "side-nav__navigation-item",
        key: "side-nav__navigation-item__".concat(i)
      }, React.createElement(NavLink, {
        exact: true,
        to: linkResolver(link),
        className: "side-nav__navigation-item-link",
        onClick: hideOverlay
      }, label));
    }))), React.createElement("ul", {
      className: "side-nav__contact"
    }, React.createElement("li", {
      className: "side-nav__contact-item"
    }, React.createElement("a", {
      href: "tel:+48799399390"
    }, React.createElement(ReactSVG, {
      path: PhoneImage,
      className: "side-nav__contact-item-icon"
    }), React.createElement("span", null, "+48 799 399 390"))), React.createElement("li", {
      className: "side-nav__contact-item"
    }, React.createElement("a", {
      href: "mailto:drzwiprzesuwne@reno-reno.pl"
    }, React.createElement(ReactSVG, {
      path: EmailImage,
      className: "side-nav__contact-item-icon"
    }), React.createElement("span", null, "drzwiprzesuwne@reno-reno.pl"))))));
  });
};

export default NavList;